import { resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-c2aa45d0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "item xag-flex" }
const _hoisted_2 = ["src"]
const _hoisted_3 = { class: "xag-flex-1" }
const _hoisted_4 = { class: "up-box" }
const _hoisted_5 = { key: 0 }
const _hoisted_6 = { class: "down-box" }
const _hoisted_7 = { class: "footer" }
const _hoisted_8 = ["innerHTML"]
const _hoisted_9 = ["innerHTML"]
const _hoisted_10 = { key: 2 }
const _hoisted_11 = ["onClick", "src"]
const _hoisted_12 = { key: 0 }
const _hoisted_13 = {
  key: 1,
  class: "no-data-box xag-flex-center"
}
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("i", { class: "device-no-data-icon" }),
  /*#__PURE__*/_createElementVNode("div", null, "暂无服务历史记录")
], -1))
const _hoisted_15 = [
  _hoisted_14
]
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "xag-page__footer" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_app_header = _resolveComponent("app-header")!
  const _component_van_list = _resolveComponent("van-list")!
  const _component_van_pull_refresh = _resolveComponent("van-pull-refresh")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_app_header, { title: "服务历史" }),
    _createVNode(_component_van_pull_refresh, {
      modelValue: _ctx.refreshing,
      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.refreshing) = $event)),
      onRefresh: _ctx.onRefresh,
      class: "xag-container items-box"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_van_list, {
          loading: _ctx.loading,
          "onUpdate:loading": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.loading) = $event)),
          finished: _ctx.finished,
          error: _ctx.error,
          "onUpdate:error": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.error) = $event)),
          "error-text": "请求失败，点击重新加载",
          onLoad: _ctx.onLoad,
          class: _normalizeClass({ 'xag-flex-center': !_ctx.items.length && _ctx.finished })
        }, {
          finished: _withCtx(() => [
            (_ctx.items.length)
              ? (_openBlock(), _createElementBlock("div", _hoisted_12, "没有更多了"))
              : (_openBlock(), _createElementBlock("div", _hoisted_13, _hoisted_15))
          ]),
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.displayItems, (item, i) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "panel-box",
                key: i
              }, [
                _createElementVNode("div", _hoisted_1, [
                  _createElementVNode("img", {
                    src: 
              item.show_avatar
                ? item.avatar || '/images/service_histories_icon.png'
                : '/images/service_histories_icon.png'
            ,
                    alt: ""
                  }, null, 8, _hoisted_2),
                  _createElementVNode("div", _hoisted_3, [
                    _createElementVNode("div", _hoisted_4, [
                      (item.warehouse)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString(item.warehouse) + "：", 1))
                        : _createCommentVNode("", true),
                      _createTextVNode(_toDisplayString(item.create_by), 1)
                    ]),
                    _createElementVNode("div", _hoisted_6, _toDisplayString(item.created_at), 1)
                  ])
                ]),
                _createElementVNode("div", _hoisted_7, [
                  (item.title)
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 0,
                        innerHTML: item.title
                      }, null, 8, _hoisted_8))
                    : _createCommentVNode("", true),
                  (item.remark)
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 1,
                        innerHTML: item.remark
                      }, null, 8, _hoisted_9))
                    : _createCommentVNode("", true),
                  (item.imgs && item.imgs.length)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.imgs, (url, j) => {
                          return (_openBlock(), _createElementBlock("img", {
                            class: "img-box",
                            onClick: ($event: any) => (_ctx.getBigImages(j, item.imgs)),
                            src: url,
                            key: j,
                            alt: ""
                          }, null, 8, _hoisted_11))
                        }), 128))
                      ]))
                    : _createCommentVNode("", true)
                ])
              ]))
            }), 128))
          ]),
          _: 1
        }, 8, ["loading", "finished", "error", "onLoad", "class"])
      ]),
      _: 1
    }, 8, ["modelValue", "onRefresh"]),
    _hoisted_16
  ], 64))
}